export type GridEntityIdType = "ein" | "ssn" | "unknown";
export type GridEntityType = "company" | "individual";

export const getGridEntityIdType = (taxId?: string): GridEntityIdType => {
  if (!taxId) return "unknown";

  const normalizedTaxId = taxId.trim();

  if (/^(\d{3}|\*{3})-(\d{2}|\*{2})-\d{4}$/.test(normalizedTaxId)) {
    return "ssn";
  }

  if (/^\d{2}-\d{7}$/.test(normalizedTaxId)) {
    return "ein";
  }

  return "unknown";
};

export const getGridEntityType = (data?: {
  SourceTaxId?: string;
  ClientType?: string;
}): GridEntityType => {
  if (data?.ClientType?.trim().toLowerCase() === "individual") {
    return "individual";
  }

  return getGridEntityIdType(data?.SourceTaxId) === "ssn" ? "individual" : "company";
};
